// this file is generated by update_shopify_store_data.py at 2026-11-03 20:13:14.935837
var courses = [
    {
        "course_id": "BABB6F99-2248-EF11-998E-005056A70840",
        "course_version": 1,
        "name": "ANA: The Basic Science of Viruses (Free)",
        "course_type": 1,
        "author_information": "",
        "description": "Overview\r\nThis course examines how viruses look and how viruses affect the cells they infect. This includes a review of your foundational knowledge of virology as a nurse. You will learn how to apply this knowledge to infection control practices.\r\nHealthcare workers of all professionals may also benefit from this course.\r\nWhy is this course important to you?\r\nKnowing how viruses work will help you to understand the infection control actions that work to keep them from spreading.",
        "learning_objectives_html": "At the conclusion, participants should be able to:\r\n<br />\r\nIdentify the three (3) basic parts of a virus\r\n<br />\r\nDescribe how infection control practices may be different for envelope and non-envelope viruses",
        "course_outline_html": "",
        "credit_info": "-",
        "categories": [
            {
                "course_category_id": "1F4B1A8B-1EC9-E511-8771-005056B104B1",
                "course_category_name": "Nurse Midwife",
                "is_system_course_category": null
            },
            {
                "course_category_id": "CD33B687-264F-DB11-9011-000423ACEF71",
                "course_category_name": "Infection Control",
                "is_system_course_category": null
            },
            {
                "course_category_id": "4FF3BFFA-D08C-EB11-80DF-005056B134EC",
                "course_category_name": "Bloodborne Pathogens",
                "is_system_course_category": null
            },
            {
                "course_category_id": "41A45D8A-264F-DB11-9011-000423ACEF71",
                "course_category_name": "Pharmacology",
                "is_system_course_category": null
            },
            {
                "course_category_id": "7C6F7677-8F9E-E511-9627-005056B1456A",
                "course_category_name": "Nurse Practitioner",
                "is_system_course_category": null
            },
            {
                "course_category_id": "8FAC2CA7-C884-EE11-998F-005056A7C6AF",
                "course_category_name": "ANA - American Nurses Association",
                "is_system_course_category": null
            },
            {
                "course_category_id": "306B4D00-C749-E611-832F-005056B17E48",
                "course_category_name": "Environmental Services",
                "is_system_course_category": null
            },
            {
                "course_category_id": "18DBACB6-C884-EE11-998F-005056A7C6AF",
                "course_category_name": "ANA - American Nurses Association",
                "is_system_course_category": null
            },
            {
                "course_category_id": "C98E2D7E-1EC9-E511-8771-005056B104B1",
                "course_category_name": "Nurse Anesthetist",
                "is_system_course_category": null
            },
            {
                "course_category_id": "5EC7EE02-0083-EE11-9986-005056A740BF",
                "course_category_name": "ANA - American Nurses Association",
                "is_system_course_category": null
            },
            {
                "course_category_id": "F52D6401-D18C-EB11-80DF-005056B134EC",
                "course_category_name": "Airborne, Droplet, and Isolation Precautions",
                "is_system_course_category": null
            },
            {
                "course_category_id": "01DE6ED9-D88C-EB11-80DF-005056B134EC",
                "course_category_name": "Hand Hygiene",
                "is_system_course_category": null
            }
        ],
        "ce_accreditation": {
            "accrediting_body_name": "ANCC",
            "accreditation_statement": "American Nurses Association is accredited with distinction as a provider of nursing continuing professional development by the American Nurses Credentialing Center's Commission on Accreditation.",
            "course_level_accreditation_statement": "",
            "credit_display_name": "ANCC CNE Credit",
            "credit_units": 0.5,
            "credit_unit_display_name": "ANCC Contact\r\nHour(s)"
        },
        "sub_courses": []
    }
];